/* eslint-disable no-console */
<template>
  <div>
    <b-form @submit.prevent="siteSearchReach">
      <b-form-row class="mb-2">
        <b-col
          sm="6"
          md="6"
          lg="2"
        >
          <label for="reach-date-from">Consumption date from</label><br>
          <p class="d-inline-block fontsizeconsumptionp">
            {{ dateFrom }}
          </p>
        </b-col>

        <b-col
          sm="6"
          md="6"
          lg="2"
        >
          <label for="reach-date-to">Consumption date to</label><br>
          <p class="d-inline-block fontsizeconsumptionp">
            {{ dateTo }}
          </p>
        </b-col>

        <b-col
          sm="6"
          md="6"
          lg="2"
          style="min-width: 13.5rem;"
        >
          <label for="target-group">Reach criteria</label>
          <b-form-select
            id="target-group"
            v-model="minViewingTimeSelection"
            :options="minViewingTimeOptions"
            size="sm"
          />
        </b-col>

        <b-col
          sm="6"
          md="6"
          lg="2"
          class="align-self-center"
        >
          <b-button
            id="refresh-reach"
            type="submit"
            class="float-right"
            variant="primary"
            size="sm"
          >
            <b-icon icon="arrow-repeat" /> Update
          </b-button>
        </b-col>
      </b-form-row>
      <b-form-row
        v-if="autoChangeEndDate"
        class="mb-2 redText"
      >
        <b-col
          sm="12"
          md="6"
          lg="4"
        >
          <span>Your selection exceeded the limitation that the consumption period may be a maximum of 28 days for reach & frequency. We have therefore automatically adjusted the end date to a shorter interval.</span>
        </b-col>
      </b-form-row>
    </b-form>

    <div
      v-if="loadingSite && measureSelected"
      class="text-center mb-2"
    >
      <hr>
      <b-spinner
        variant="primary"
        type="grow"
        label="Spinning"
      />
      <div>
        <small class="text-muted">Loading reach and frequency...</small>
      </div>
    </div>
    <div v-else-if="measureSelected">
      <hr>
      <p class="mb-0">
        <small>
          Number of sites:
          <span class="font-weight-bold">
            {{ numberOfUniqueSitesInQueryKeys }}
          </span>
        </small>
      </p>
      <p class="mb-0">
        <small>
          Number of dates/response rows:
          <span class="font-weight-bold"> {{ numberOfRowsInResult }} </span>
        </small>
      </p>
      <p>
        <small>
          Panel day: <span class="font-weight-bold"> {{ panelDaySite }} </span>
        </small>
      </p>
      <div class="d-flex">
        <b-form-radio-group
          v-model="measureTypeSelected"
          class="mr-auto"
          :options="measureTypeOptions"
          name="Relative or absolute"
          buttons
          button-variant="outline-primary"
        />
        <SiteReachExport
          :json="itemsSite"
          :header-items="headerItems"
        />
      </div>

      <b-table
        v-if="meassureType === 'absolute_reach'"
        id="reach-summary"
        class="mt-2"
        :bordered="true"
        :striped="true"
        :head-variant="'dark'"
        :items="itemsSite"
        :fields="fieldsAbsSite"
        :small="true"
        :responsive="true"
      />

      <b-table
        v-else-if="meassureType === 'relative_reach'"
        id="reach-summary"
        class="mt-2"
        :bordered="true"
        :striped="true"
        :head-variant="'dark'"
        :items="itemsSite"
        :fields="fieldsRelSite"
        :small="true"
        :responsive="true"
      />
    </div>
    <div
      v-else
      class="text-center mb-2"
    >
      <hr>
      <small
        class="text-danger"
      ><strong>You must select a target group under target / metric</strong></small>
    </div>
  </div>
</template>

<script>
import SiteReachExport from '../../Layout/Site/SiteReachExport';
import { daysBetween, addDays } from '../../../assets/js/utils.js';
import { mapGetters } from 'vuex';
import { dateToyymmddFormat } from '../../../assets/js/utils.js';

export default {
  name: 'SiteReach',
  components: {
    SiteReachExport,
  },
  data() {
    return {
      meassureType: 'absolute_reach',
    };
  },
  computed: {
    ...mapGetters([
      'itemsSite',
      'loadingSite',
      'fieldsAbsSite',
      'fieldsRelSite',
      'uniSizeSite',
      'resultCountSite',
      'panelDaySite',
    ]),
    minViewingTimeSelection: {
      get() {
        return this.$store.state.siteReachForm.min_viewing_time.selected;
      },
      set(value) {
        this.$store.commit('siteReachForm/updateMinViewingTimeSite', value);
        this.$store.commit('siteReachApiBody/updateMinViewingTimeSite', value);
      },
    },
    minViewingTimeOptions() {
      return this.$store.state.siteReachForm.min_viewing_time.options;
    },
    measureTypeSelected: {
      get() {
        return this.$store.state.siteReachForm.measure_type.selected;
      },
      set(value) {
        this.meassureType = value;
        this.$store.commit('siteReachForm/updateMeasureTypeSite', value);
      },
    },
    measureTypeOptions() {
      return this.$store.state.siteReachForm.measure_type.options;
    },
    dateFrom: {
      get() {
        return this.$store.state.siteReachApiBody.payload.start_date;
      },
    },
    dateTo: {
      get() {
        return this.$store.state.siteReachApiBody.payload.end_date;
      },
    },
    measures() {
      return this.$store.state.siteReachApiBody.payload.measures;
    },
    numberOfSelectedRows() {
      return this.$store.state.siteReachApiBody.payload.queryKeys.length;
    },
    numberOfUniqueSitesInQueryKeys() {
      let queryKeys = this.$store.state.siteReachApiBody.payload.queryKeys.map(function(i) {
        return i.split(';');
      });
      let uniqueSites = [...new Set(queryKeys.map(item => item[0]))];
      return uniqueSites.length;
    },
    numberOfRowsInResult() {
      let dateItemsSite = this.itemsSite.filter(function(itemSite) {
        if (dateToyymmddFormat(itemSite.date_key) !== 'Invalid Date') return itemSite;
      });
      return dateItemsSite.length;
    },
    autoChangeEndDate() {
      return this.$store.state.siteReachApiBody.autoChangeEndDate;
    },
    headerItems() {
      return [
        {
          date_key: 'Period',
          measure_1: `${this.dateFrom}--${this.dateTo}`,
        },
        {
          date_key: 'Panel day',
          measure_1: this.panelDaySite,
        },
        {
          date_key: 'Number of sites',
          measure_1: this.numberOfUniqueSitesInQueryKeys,
        },
        {
          date_key: 'Number of dates/response rows',
          measure_1: this.numberOfRowsInResult,
        },
      ];
    },
    measureSelected() {
      const measuresSite = this.$store.state.siteApiBody.payload.measures
      return measuresSite.length > 0
    },
  },
  watch: {
    '$store.state.siteReachResults.showToastErrorSite'() {
      if (this.$store.state.siteReachResults.showToastErrorSite) {
        this.$bvToast.toast('Unknown server error when fetching site reach & frequency results', {
          title: 'Error',
          variant: 'danger',
          solid: true,
          autoHideDelay: 5000,
          bodyOutputType: 'trustedHtml',
        });
        this.$store.state.siteReachResults.showToastErrorSite = false;
      }
    },
  },
  methods: {
    siteSearchReach() {
      if (this.minViewingTimeSelection == -1) {
        this.$bvToast.toast('You must select a reach criteria.', {
          title: 'Invalid reach criteria',
          variant: 'danger',
          solid: true,
          autoHideDelay: 5000,
          bodyOutputType: 'trustedHtml',
        });
        return;
      }
      let startDate = this.$store.state.siteReachApiBody.payload.start_date;
      let endDate = this.$store.state.siteReachApiBody.payload.end_date;
      let days = daysBetween(startDate, endDate);
      //Max days in reach is 28
      if (days >= this.config_MaxReachDays) {
        endDate = addDays(startDate, this.config_MaxReachDays - 1);
        this.$store.commit('siteReachApiBody/updateAutoChangeEndDate', true);
        this.$store.commit('siteReachApiBody/updateEndDate', endDate);
      } else {
        this.$store.commit('siteReachApiBody/updateAutoChangeEndDate', false);
      }

      this.$emit('onSiteSearchReach');
    },
    round(value, precision) {
      let multiplier = Math.pow(10, precision || 0);
      return (Math.round(value * multiplier) / multiplier).toString().replace('.', ',');
    },
  },
};
</script>
<style scoped>
.fontsizeconsumptionp {
  font-size: 0.875rem;
}
.redText {
  color: red;
  font-weight: bold;
  font-size: 0.8em;
}
</style>